module.exports = __webpack_public_path__ + "static/media/6.50741f76.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/6.mp3
// module id = 482
// module chunks = 0